import React from 'react';
import hexagonStylingLeft from '../Assets/hexagonStylingLeft.svg';
import hexagonStylingRight from '../Assets/hexagonStylingRight.svg';

function Hexagon({ID, position, name, mainTech, link}) {
    const openLink = () => {
        window.open(link, "_blank")
    }
    
    return (
        <div className={`container${position}${ID}`} data-aos="fade-up" data-aos-delay="300">
            <div className={`container${position}${ID}__hexagon`}></div>
            
            <div className={`container${position}${ID}__hexagonProject`}>
                <div className={`container${position}${ID}__hexagonProject__name`} data-aos="zoom-in" data-aos-delay="500">{name}</div>
                <div className={`container${position}${ID}__hexagonProject__tech`} data-aos="zoom-in" data-aos-delay="600">{mainTech}</div>
            </div>

            <div className={`container${position}${ID}__hexagonBorder`} onClick={openLink}>
                <div className={`container${position}${ID}__hexagonBorder__1`}></div>
                <div className={`container${position}${ID}__hexagonBorder__2`}></div>
                <div className={`container${position}${ID}__hexagonBorder__3`}></div>
                <div className={`container${position}${ID}__hexagonBorder__decoration`}>
                    <div className={`container${position}${ID}__hexagonBorder__decoration__1`}></div>
                    <div className={`container${position}${ID}__hexagonBorder__decoration__2`}></div>
                </div>
            </div>
            
            <div className={`container${position}${ID}__hexagonStyle`}>
                {
                    (ID % 2 !== 0) ? (
                        <img src={hexagonStylingRight} alt="Hexagon Style" />
                    ) : (
                        <img src={hexagonStylingLeft} alt="Hexagon Style" />
                    )
                }
            </div>
        </div>
    );
}

export default Hexagon



// WEBPACK FOOTER //
// ./src/Components/Projects/JavaScript/Hexagon.js